/** Replace backslashes with forward slashes. */
export function slash(str) {
    return str.replace(/\\/g, '/');
}
//# sourceMappingURL=slash.js.map